<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        class="mb-2"
      >
        <label class="text-capitalize font-weight-bold">
          {{ $t("user_group_selection_option.user") }}
        </label>

        <p class="text-muted small mb-1">
          {{ $t('user_group_selection_option.bulk.filter_hint') }}
        </p>

        <users-select-paginated
          :value="userFilter"
          endpoint="/v1/users"
          label-key="full_name"
          :show-email-in-label="true"
          @input="
            (value) =>
              $emit(
                'update:userFilter',
                value
              )
          "
        />
      </b-col>
    </b-row>

    <b-alert
      v-if="userFilter"
      show
      variant="light-primary"
      class="mb-0"
    >
      <div
        class="
          d-flex
          align-items-center
          justify-content-between
        "
      >
        <div>
          <div class="font-weight-bold">
            {{ $t('user_group_selection_option.bulk.active_filter') }}
          </div>

          <div class="small">
            {{
              getUserLabel(
                userFilter
              )
            }}
          </div>
        </div>

        <b-button
          variant="flat-secondary"
          size="sm"
          @click="
            $emit(
              'update:userFilter',
              null
            )
          "
        >
          <feather-icon
            icon="XIcon"
            size="15"
            class="mr-25"
          />

          {{ $t('user_group_selection_option.bulk.clear') }}
        </b-button>
      </div>
    </b-alert>
  </div>
</template>

<script>
import i18n from "@/libs/i18n";
import {
  BAlert,
  BButton,
  BCol,
  BRow,
} from "bootstrap-vue";

import UsersSelectPaginated
  from "@/components/UsersSelectPaginated.vue";

export default {
  name:
    "UserGroupSelectionOptionFilters",

  components: {
    BAlert,
    BButton,
    BCol,
    BRow,

    UsersSelectPaginated,
  },

  props: {
    userFilter: {
      type: [
        Object,
        Number,
        String,
      ],

      default: null,
    },
  },

  setup() {
    const getUserLabel = (
      user
    ) => {
      if (!user) {
        return "";
      }

      if (
        typeof user !==
        "object"
      ) {
        return i18n.t("user_group_selection_option.bulk.user_fallback", { id: user });
      }

      const name =
        user.full_name ??
        user.label ??
        user.name ??
        "";

      const email =
        user.email ?? "";

      if (
        name &&
        email &&
        !name.includes(email)
      ) {
        return `${name} | ${email}`;
      }

      return (
        name ||
        email ||
        i18n.t("user_group_selection_option.bulk.user_fallback", { id: user.id ??
          user.value ??
          "" })
      );
    };

    return {
      getUserLabel,
    };
  },
};
</script>
